import { useDispatch, useSelector } from 'react-redux';
import MojitoServices from 'mojito/services';
import MojitoCore from 'mojito/core';
import Utils from 'modules/share-dialog/utils.js';

const { selectBetslip } = MojitoServices.Betslip.selectors;
const { actions: betslipActions, utils: betslipUtils } = MojitoServices.Betslip;
const { selectAffiliateId } = MojitoServices.UserInfo.selectors;
const { Hooks } = MojitoCore.Presentation;
const { SHARE_LINK_TYPE } = MojitoServices.Sharing.types;

/**
 * HoC wraps CommitBetslipButton implementation with sports betslip specific handling.
 *
 * @function withSportShareBet
 * @param {React.ReactElement} CommitBetslipButton - Place bet button view implementation.
 * @returns {React.ReactElement} Share bet button react component.
 * @memberof Mojito.Modules.BetslipView
 * @private
 */
export default function withSportShareBet(CommitBetslipButton) {
    return function ShareBetButton(props) {
        const dispatch = useDispatch();
        const appContext = Hooks.useAppContext();

        const betslip = useSelector(selectBetslip);
        const affiliate = useSelector(selectAffiliateId);

        const onShareBetButtonClick = () => {
            const path = Utils.getDeeplink(appContext.routeResolver);
            const betRefs = betslipUtils.extractBetRefs(betslip);
            dispatch(
                betslipActions.fetchBetShareUrl({
                    path,
                    betRefs,
                    affiliate,
                    type: SHARE_LINK_TYPE.SHARE,
                })
            );
        };

        return (
            <CommitBetslipButton
                {...props}
                affiliateId={affiliate}
                onCommit={onShareBetButtonClick}
            />
        );
    };
}
